import React from "react";
import ReactDOM from "react-dom";
import { SharerItems } from "./components/SharerItems";

const sharerElement = document.getElementById("sharer");

const Sharer = () => {
  if (window.innerWidth < 991) return null;

  const { title, link } = sharerElement.dataset;

  return (
    <>
      <div className="sharer__label">
        <i class="fal fa-share-alt"></i>Delen
      </div>
      <SharerItems includeMail={false} link={link} title={title} />
    </>
  );
};

if (sharerElement) {
  ReactDOM.render(<Sharer />, sharerElement);
}
